var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVilleOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103.3 130.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #e1543e;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 103.3,
    height: 130.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 103.3,
    height: 130.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 103.3,
    height: 130.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,60.6v42.7h103.3v-42.7h-26l1.8,22.5c.7,6.2,0,7.2,1.8,7.2h4v2.8h-22.2v-2.8c3.8,0,4.3,0,4.3-.8l-2.6-35.3-15,37.2c-.4.8-.5,1.6-1.3,1.6s-.7-.5-.9-.9l-14.8-34.3-2.4,27.6c-.3,3.8-.6,4.8,2.2,4.9h2.5v2.8h-13.9v-2.8h2.7c.7,0,1.6,0,1.6-.8l2.2-28.9H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,0h103.3v59.5h-26s-.9-11.2-.9-11.2c.2-1.4.4-1.4,1.4-1.4h2.6v-2.8h-16.7l-12.2,30.9-12.9-30.9h-17.4v2.8c4.3,0,7.2-.5,6.8,4.8l-.6,7.8H0S0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 104.6,
    width: 103.3,
    height: 26.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6.1 111.2 11.9 111.2 13.2 118 14.6 111.2 20.2 111.2 20.2 113.6 19.1 113.6 19.1 120.7 20.2 120.7 20.2 123.1 15.6 123.1 15.6 120.7 16.4 120.7 16.4 113.7 14.1 123.1 11.8 123.1 9.6 113.6 9.6 120.7 10.3 120.7 10.3 123.1 6.1 123.1 6.1 120.7 7.2 120.7 7.2 113.6 6.1 113.6 6.1 111.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,114.7c.8-.4,1.7-.5,2.4-.5,3,0,4.5,1.8,4.5,4.6s0,1.3-.3,1.9c-.4,1.3-1.2,1.9-1.9,2.2-.7.3-1.6.4-2.3.4s-.8,0-1.2-.1c-.7-.1-1.4-.4-2-1-1.2-1.2-1.2-2.8-1.2-3.6s0-2.9,2-3.9M25.4,116.5c-.3,0-.6,0-.8.3-.5.5-.5,1.4-.5,1.9s0,1,.3,1.5c.2.3.4.7,1,.7,1.2,0,1.2-1.6,1.2-2.2s0-2.2-1.2-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.6,120.7h.7v2.4h-3.9v-5.8c-.2-.4-.5-.5-.8-.5l-.6.3c-.3.3-.3.7-.3,1.2v2.4h.6v2.4h-4.4v-2.4h.7v-3.9h-.7v-2.4h3.5v1.3c.1,0,.6-.7.6-.7.5-.5,1.2-.9,2.2-.9s1.5.3,1.8.7c.6.6.6,1.3.6,1.9v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.5,111.6v2.7h1.4v2.4h-1.4v3.1c0,.3,0,1,.9,1h.5c0,0,0,2.2,0,2.2-.6,0-1.2.2-1.8.2-1,0-1.7-.3-2.1-.6-.5-.5-.5-1.1-.5-1.6v-4.3h-.8v-2.4h1v-2.1l2.9-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.3,115.3c.4-.5.9-1.2,2.3-1.2s1.4,0,2.2.9c1.2,1.2,1.2,3,1.2,3.7s0,4.6-3.4,4.6-1.4,0-2-1l-.2-.3v2.1h.8v2.4h-4.6v-2.4h.7v-7.4h-.7v-2.4h3.7v1ZM50.9,116.8c-.5.5-.5,1.4-.5,1.7,0,1.5.3,2,.5,2.2l.7.3c.6,0,1.2-.6,1.2-2.2s0-.9-.2-1.4c-.2-.5-.5-.9-1-.9l-.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.4,120.1c-.1.6-.3,1.5-1,2.2-.8.7-1.9,1-3,1-2.3,0-4.4-1.1-4.4-4.5s0-1.1.2-1.8c.6-2,2.2-2.9,4-2.9s2.5.5,3.1,1.1c1.3,1.3,1.2,3.3,1.2,4.1h-5.3c0,.7,0,1.9,1.1,1.9s1-.8,1.1-1.1h3ZM62.3,117.7v-.7c-.3-.5-.7-.6-1.1-.6-1,0-1.1,1-1.1,1.3h2.1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "66.3 111.2 70.2 111.2 70.2 120.7 70.9 120.7 70.9 123.1 66.3 123.1 66.3 120.7 67 120.7 67 113.6 66.3 113.6 66.3 111.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "71.6 111.2 75.5 111.2 75.5 120.7 76.2 120.7 76.2 123.1 71.6 123.1 71.6 120.7 72.3 120.7 72.3 113.6 71.6 113.6 71.6 111.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.8,114.4v6.3h.7v2.4h-4.6v-2.4h.7v-3.9h-.7v-2.4h3.9ZM77.4,111.2h3.4v2.3h-3.4v-2.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.7,120.1c-.1.6-.3,1.5-1.1,2.2-.8.7-1.9,1-3,1-2.3,0-4.4-1.1-4.4-4.5s0-1.1.2-1.8c.6-2,2.2-2.9,4-2.9s2.5.5,3.1,1.1c1.3,1.3,1.2,3.3,1.2,4.1h-5.3c0,.7,0,1.9,1.1,1.9s1-.8,1.1-1.1h3ZM87.7,117.7v-.7c-.3-.5-.7-.6-1.1-.6-1,0-1,1-1,1.3h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.2,115.9c.1-.5.5-1.6,2.1-1.6s.6,0,.8.1v2.8h-.7c-.6,0-1.2.1-1.5.4-.4.4-.4.9-.4,1.7v1.4s1,0,1,0v2.4h-4.8v-2.4h.7v-3.9h-.7v-2.4h3.4v1.5Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVilleOrange);
export default __webpack_public_path__ + "static/media/Logo-Ville-orange.5865dd05171af95b1274b10b61912493.svg";
export { ForwardRef as ReactComponent };